import { css } from 'styled-components';

const base = css`
  font-family: 'Inter Variable', 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const typography = {
  h1: css`
    ${base}
    font-size: 48px;
    font-weight: 650;
    line-height: 48px;
    letter-spacing: -0.48px;
  `,
  h2: css`
    ${base}
    font-size: 38px;
    font-weight: 650;
    line-height: 38px;
    letter-spacing: -0.38px;
  `,
  h3: css`
    ${base}
    font-size: 32px;
    font-weight: 650;
    line-height: 36px;
    letter-spacing: -0.32px;
  `,
  h4: css`
    ${base}
    font-size: 24px;
    font-weight: 650;
    line-height: 28px;
    letter-spacing: -0.48px;
  `,
  h5: css`
    ${base}
    font-size: 20px;
    font-weight: 650;
    line-height: 24px;
    letter-spacing: -0.2px;
  `,
  h6: css`
    ${base}
    font-size: 16px;
    font-weight: 650;
    line-height: 20px;
  `,
  p1: css`
    ${base}
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
  `,
  p2: css`
    ${base}
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  `,
  p3: css`
    ${base}
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
  `,
  label: css`
    ${base}
    font-size: 13px;
    font-weight: 500;
    line-height: 15px;
  `,
};

export default typography;
